/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React from "react";
import { Table, Pagination } from "antd";
import { compose } from "recompose";

import { CardPagination, CardTable } from "../../components/Table";
import { withGlobalContext } from "../../utils/globalContext";

const SELECTION_STATE = {
  SELECT_ALL_FROM_PAGE: 1,
  SELECT_ALL: 2,
  CANCEL: 0,
};

const TableList = ({
  data,
  loading,
  totalData,
  currentPage,
  pageSize,
  onChange,
  columns,
  onlyShowList,
  rowSelection,
  scroll,
  size,
  showHeader,
  heightcustom,
  footer,
  heightempty,
  withoutscroll,
  backgroundcustom,
  expandedRowRender,
  expandRowByClick,
  expandIconColumnIndex,
  expandIcon,
  forPrint,
  setItems,
  setSelectAll,
  showSpan,
  setShowSpan,
  pagination = false,
  rowKey,
  onExpand,
}) => {
  const firstUpdate = React.useRef(true);
  const [selectedAllFromPage, setSelectedAllFromPage] = React.useState(false);
  const [rows, setRows] = React.useState(data.length);
  const [selectionState, setSelectionState] = React.useState(
    selectedAllFromPage
      ? SELECTION_STATE.SELECT_ALL_FROM_PAGE
      : SELECTION_STATE.CANCEL
  );
  const [selectedRowKeys, setSelectedRowKeys] = React.useState(
    (forPrint && rowSelection.selectedRowKeys) ||
      (rowSelection && rowSelection.selectedRowKeys) ||
      []
  );

  React.useEffect(() => {
    if (selectedAllFromPage) setSelectionState(1);
    setRows(data.length);
  }, [selectedAllFromPage, data.length]);

  React.useEffect(() => {
    if (firstUpdate.current) firstUpdate.current = false;
    else if (!showSpan) {
      setSelectionState(SELECTION_STATE.CANCEL);
      setSelectedRowKeys([]);
    } else setSelectionState(SELECTION_STATE.SELECT_ALL_FROM_PAGE);
  }, [showSpan]);

  const onClick = value => {
    if (selectionState === SELECTION_STATE.SELECT_ALL_FROM_PAGE) {
      setSelectionState(SELECTION_STATE.SELECT_ALL);
      setSelectAll(true);
    } else if (selectionState === SELECTION_STATE.SELECT_ALL) {
      setSelectionState(SELECTION_STATE.CANCEL);
      setSelectedRowKeys([]);
      setSelectedAllFromPage(false);
      setItems([]);
      setSelectAll(false);
    }

    setRows(value);
  };

  const cardPagination = (
    <CardPagination>
      <span
        style={{
          height: 32,
          padding: "0.5rem 2rem",
          alignSelf: "center",
        }}
      >
        {`Total ${totalData || 0} registros`}
      </span>
      <Pagination
        simple
        pageSize={pageSize}
        total={totalData}
        onChange={onChange}
      />
    </CardPagination>
  );

  const onSelectChange = (selectedRK, selectedRows) => {
    if (selectedRowKeys && selectedRowKeys.length !== selectedRK.length) {
      setSelectionState(SELECTION_STATE.CANCEL);
      setSelectedAllFromPage(false);
      if (forPrint) setSelectAll(false);
    }
    setSelectedRowKeys(selectedRK);
    if (forPrint) setItems(selectedRows);
  };

  const onSelectAll = (selected, selectedRows) => {
    if (forPrint) setShowSpan(true);
    setSelectedAllFromPage(selected);
    if (forPrint) setItems(selectedRows);
  };

  return (
    <React.Fragment>
      <CardTable
        heightcustom={heightcustom}
        heightempty={heightempty}
        withoutscroll={withoutscroll}
        backgroundcustom={backgroundcustom}
      >
        <Table
          expandedRowRender={expandedRowRender}
          showHeader={showHeader}
          footer={footer}
          size={size}
          onChange={onChange}
          rowSelection={
            forPrint
              ? {
                  onChange: onSelectChange,
                  onSelectAll,
                  selectedRowKeys,
                }
              : rowSelection
          }
          loading={loading}
          pagination={pagination}
          columns={columns.map(item => ({ ...item, ellipsis: true }))}
          dataSource={data}
          rowKey={rowKey || (value => value.key)}
          scroll={
            scroll || {
              x: "fit-content",
            }
          }
          expandRowByClick={expandRowByClick}
          onExpand={onExpand}
          expandIconAsCell={false}
          expandIconColumnIndex={expandIconColumnIndex}
          expandIcon={expandIcon}
        />
      </CardTable>
      {!onlyShowList ? (
        forPrint ? (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {showSpan &&
            selectedAllFromPage &&
            selectionState !== SELECTION_STATE.CANCEL ? (
              <div style={{ display: "flex" }}>
                <span
                  style={{
                    height: 52,
                    padding: "0.5rem 2rem",
                    alignSelf: "left",
                    display: "flex",
                    alignItems: "center",
                    paddingRight: 0,
                  }}
                >
                  {selectionState === SELECTION_STATE.SELECT_ALL_FROM_PAGE ? (
                    <React.Fragment>
                      Se han seleccionado los&nbsp;<b>{rows}</b> &nbsp;tracks de
                      esta página.
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      Se han seleccionado los&nbsp;<b>{rows}</b> &nbsp;tracks.
                    </React.Fragment>
                  )}
                </span>
                <span
                  style={{
                    height: 52,
                    padding: "0.5rem 2rem",
                    alignSelf: "left",
                    display: "flex",
                    alignItems: "center",
                    color: "#1890ff",
                    paddingLeft: 5,
                    cursor: "pointer",
                  }}
                  onClick={() => onClick(totalData)}
                >
                  {selectionState === SELECTION_STATE.SELECT_ALL_FROM_PAGE ? (
                    <React.Fragment>
                      Seleccionar los&nbsp;<b>{totalData}</b>&nbsp;tracks.
                    </React.Fragment>
                  ) : selectionState === SELECTION_STATE.SELECT_ALL ? (
                    <React.Fragment>Anular selección</React.Fragment>
                  ) : null}
                </span>
              </div>
            ) : (
              <span></span>
            )}
            {cardPagination}
          </div>
        ) : (
          cardPagination
        )
      ) : null}
    </React.Fragment>
  );
};

export default compose(withGlobalContext)(TableList);
